import { useCallback } from 'react';
import { useFormatter } from 'next-intl';

export const usePriceFormatter = (currency: Currency) => {
  const format = useFormatter();
  return useCallback(
    (price: number) => {
      return format.number(price, {
        style: 'currency',
        currency: currency.isoCode,
        maximumFractionDigits: currency.decimalCount,
        minimumFractionDigits: currency.decimalCount,
      });
    },
    [format, currency.isoCode, currency.decimalCount]
  );
};

export const useCentPriceFormatter = (currencyCode: string) => {
  const format = useFormatter();
  return useCallback(
    (price: number) => {
      return format.number(price / 100, {
        style: 'currency',
        currency: currencyCode,
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });
    },
    [format, currencyCode]
  );
};
